export const blockIconsSearchChair = (
	<span className='material-symbols-outlined'>chair</span>
);
